import { render, staticRenderFns } from "./TanzaniaPrices.vue?vue&type=template&id=257a9663&"
import script from "./TanzaniaPrices.vue?vue&type=script&lang=js&"
export * from "./TanzaniaPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports